import React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { Text, Skeleton } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { usePlanLocation } from 'hooks/use-plan-location.hook';
import { GET_PLAN_NAME } from './page-heading.api';

const getCopy = copyFor('headings');

interface Props {
  page: string;
}

export const PageHeading = ({ page }: Props) => {
  const { planId } = useParams<{ planId?: string }>();
  const { data: planData, loading: planLoading } = useQuery<
    GetPlanNameQuery,
    GetPlanNameQueryVariables
  >(GET_PLAN_NAME, {
    skip: !planId,
    variables: { id: Number(planId) || -1 },
  });
  const { data, loading } = usePlanLocation({
    planId: Number(planId),
  });

  const address = data?.displayServiceAddress;
  const nickname = planData?.plan.name;
  const subTitleKey: 'subTitleWithNickname' | 'subTitle' = `subTitle${
    nickname ? 'WithNickname' : ''
  }`;

  if (loading || planLoading)
    return (
      <Container margin="40px 0" small={{ margin: '40px 24px 40px' }}>
        <Skeleton backgroundColor="tertiary" opacity="low" height="40px" />
        <Skeleton
          backgroundColor="tertiary"
          opacity="low"
          margin={{ top: '8px' }}
          height="24px"
          width="400px"
        />
      </Container>
    );

  return (
    <Container margin="40px 0" small={{ margin: '40px 24px 40px' }}>
      <Text tag="h1" textStyle="heading900">
        {page}
      </Text>
      {address && (
        <Text margin={{ top: '8px' }}>
          {getCopy(subTitleKey, { address, nickname })}
        </Text>
      )}
    </Container>
  );
};
